import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import operatorDeleteAction from './operatorDelete.action.json' with { type: 'json' }

const operatorDeleteDefinition = defineAction({
  ...operatorDeleteAction,

  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default operatorDeleteDefinition
